<div class="flex flex-col justify-center items-center">
  <img src="../../../../assets/no-data.png" class="max-w-56 my-6" [ngClass]="[heightClass]"/>
  <p>{{ title | translate }}</p>
  <p class="text-xs">{{ label | translate }}</p>
</div>